import { render } from "./VitDropdownItem.vue?vue&type=template&id=9b90a740&ts=true"
import script from "./VitDropdownItem.vue?vue&type=script&lang=ts"
export * from "./VitDropdownItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__